module.exports = "pegasus_template/assets/themelp1/large/53.png";